import { Routes } from '@angular/router';

export const reportsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./reports.component').then((m) => m.ReportsComponent),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./components/report-detail/report-detail.component').then(
        (m) => m.ReportDetailComponent
      ),
  },
];
